module.exports = __webpack_public_path__ + "img/sale-info.2a58f8a8.png";